import React from "react";
import LabelTemplate, { actions } from "../LabelTemplate";

// eslint-disable-next-line react/prop-types
export default function ActionTemplate({ action }) {
  const foundAction = actions.find((s) => s.value === action) || "---";
  return <LabelTemplate text={foundAction.value} color={foundAction.color} />;
}
